import emailjs from "@emailjs/browser";

const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;

// Human-readable labels for the appointment service select values
const SERVICE_LABELS = {
  "call-center": "Кол Център услуги",
  "chat-channels": "Управление на чат канали",
  "sales-teams": "Търговски екипи",
  "full-package": "Пълен пакет услуги",
  other: "Друго",
};

const sendEmail = (templateParams) =>
  emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, {
    publicKey: PUBLIC_KEY,
  });

export const sendContactEmail = ({ name, email, phone, message }) =>
  sendEmail({
    subject: `Ново запитване от ${name}`,
    form_type: "Контактна форма",
    from_name: name,
    name,
    email,
    phone: phone || "—",
    message: message || "—",
  });

export const sendAppointmentEmail = ({
  firstName,
  lastName,
  email,
  phone,
  company,
  service,
  message,
}) => {
  const fullName = `${firstName} ${lastName}`.trim();
  const serviceLabel = SERVICE_LABELS[service] || service || "—";
  const composedMessage = [
    `Компания: ${company || "—"}`,
    `Интересуваща услуга: ${serviceLabel}`,
    "",
    "Съобщение:",
    message || "—",
  ].join("\n");

  return sendEmail({
    subject: `Нова заявка за час от ${fullName}`,
    form_type: "Запазване на час",
    from_name: fullName,
    name: fullName,
    email,
    phone: phone || "—",
    message: composedMessage,
  });
};
